// extracted by mini-css-extract-plugin
export default {"box":"Square_box__TM4Qr"};